import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=53f63962&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53f63962')) {
      api.createRecord('53f63962', component.options)
    } else {
      api.reload('53f63962', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=53f63962&", function () {
      api.rerender('53f63962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Components/ChangePassword/ChangePassword.vue"
export default component.exports